export default () => ({
  renewalTask: null,
  ...userProfileData(),
  products: null,
  resources: null
});

export function userProfileData () {
  return {
    isAuthenticated: false,
    agencyId: null,
    userType: null,
    initials: null,
    permissions: {
      agency: null,
      office: null
    },
    cmsFlags: null,
    exp: null
  };
}
